module.exports = __webpack_public_path__ + "img/微信.b0fee8b0.png";